<main id="content" class="relative container mx-auto px-base">
  <div class="my-base">
    <!-- Botón Volver -->
    <a class="c-button c-button--transparent cursor-pointer"
       (click)="navigationService.goBack()">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 140 140" class="self-center mr-2" aria-hidden="true" focusable="false" width="1em" height="1em">
        <path d="M37.93 27.93l-35 35a10 10 0 000 14.14l35 35a10 10 0 1014.14-14.14L38.41 84.27A2.5 2.5 0 0140.18 80H130a10 10 0 000-20H40.18a2.5 2.5 0 01-1.77-4.27l13.66-13.66a10 10 0 00-14.14-14.14z" fill="currentColor"></path>
      </svg>
      Volver
    </a>
  </div>

  <div class="prose">
    <h1>Mapa web</h1>
    <p class="text-lg">
      Colección de las secciones principales de este sitio web y sus subsecciones.
    </p>
  </div>

  <!-- Gestión de currículum -->
  <div class="mb-xl">
    <h2 class="c-h2 group">
      <a class="c-link cursor-pointer" (click)="navigationService.goToCurriculum()">Gestión de currículum</a>
    </h2>
    <div class="prose mb-base">
      <p>
        Carga, búsqueda y edición de currículum vitae. Búsqueda de ofertas para un candidato, y búsqueda de candidatos para una palabra o cadena de texto.
      </p>
    </div>
    <ul>
      <li class="mb-base">
        <a class="c-link cursor-pointer" (click)="navigationService.goToCurriculumUpload()">Carga de currículum</a>
      </li>
      <li class="mb-base">
        <a class="c-link cursor-pointer" (click)="navigationService.goToCurriculumSearch()">Búsqueda de currículum</a>
      </li>
      <li class="mb-base">
        <a class="c-link cursor-pointer" (click)="navigationService.goToJobseekerSearch()">Búsqueda de candidatos</a>
      </li>
    </ul>
  </div>

  <!-- Gestión de ofertas -->
  <div class="mb-xl">
    <h2 class="c-h2">
      <a class="c-link cursor-pointer" (click)="navigationService.goToJobOffers()">Gestión de ofertas</a>
    </h2>
    <div class="prose mb-base">
      <p>
        Carga, búsqueda y edición de ofertas de empleo. Búsqueda de candidatos para una oferta.
      </p>
    </div>
    <ul>
      <li class="mb-base">
        <a class="c-link cursor-pointer" (click)="navigationService.goToJobOffersUpload()">Carga de oferta</a>
      </li>
      <li class="mb-base">
        <a class="c-link cursor-pointer" (click)="navigationService.goToJobOffersSearch()">Búsqueda de oferta</a>
      </li>
      <li class="mb-base">
        <a class="c-link cursor-pointer" (click)="navigationService.goToJobseekerSearch()">Búsqueda de candidatos</a>
      </li>
    </ul>
  </div>

  <!-- Gestión -->
  <div class="mb-xl">
    <h2 class="c-h2">
      <a class="c-link cursor-pointer" (click)="navigationService.goToManagement()">Gestión</a>
    </h2>
    <div class="prose mb-base">
      <p>Gestión de la aplicación.</p>
    </div>
    <ul>
      <li class="mb-base">
        <a class="c-link cursor-pointer" (click)="navigationService.goToManagementUsers()">Gestión de usuarios</a>
      </li>
    </ul>
  </div>

  <!-- Accesibilidad -->
  <div class="mb-xl">
    <h2 class="c-h2">
      <a class="c-link cursor-pointer" (click)="navigationService.goToAccesibilidad()">Accesibilidad</a>
    </h2>
    <div class="prose mb-base">
      <p>Conoce el nivel de accesibilidad de la web y obtén información adicional al respecto.</p>
    </div>
  </div>

  <!-- Mapa web -->
  <div class="mb-xl">
    <h2 class="c-h2">
      <a class="c-link cursor-pointer" (click)="navigationService.goToMapaWeb()">Mapa web</a>
    </h2>
    <div class="prose mb-base">
      <p>Colección de las secciones principales de este sitio web y sus subsecciones.</p>
    </div>
  </div>
</main>
